import { ILicenseFlags } from "store/entities/license";

export const hashes = {
  signupGoogleAnalyticsEventSent: "ff737469a35c54f11750cd6685cdf8e4",
} satisfies Partial<Record<keyof ILicenseFlags, string>>;
